import React from "react";
import { List, Typography, Box } from "@mui/material";
import { useTranslations } from "hooks";
import { getTranslation } from "common";
import { RolesModel } from "./NewProcessModule";
import RoleAssociationItem from "./AssociationComponents/RoleAssociationItem";
import { ExtensionElements } from "model/processModel";

//fatto su modello di AssociationList
const RoleAssociationList: React.FC<{
  listToBeDisplayed: RolesModel[];
  extensionElements: ExtensionElements | undefined;
  onLaneMouseDown: any;
  selectedLane: string;
  oppAccordianRef: any;
  containerHeight: number;
}> = ({
  listToBeDisplayed,
  extensionElements,
  onLaneMouseDown,
  selectedLane,
  containerHeight,
  oppAccordianRef,
}) => {
  const translations = useTranslations();
  const laneParticipantIds: string[] =
    (extensionElements &&
      selectedLane &&
      extensionElements[selectedLane]?.map(
        (extEl) => `${extEl.idparticipant}-${extEl.idparticipanttype}`
      )) ||
    [];

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold">
        {getTranslation(translations, "roles.name")}
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          maxHeight: containerHeight - 100,
        }}
      >
        <List dense disablePadding>
          {listToBeDisplayed.map((ele) => (
            <RoleAssociationItem
              key={`association-role-${ele.id}`}
              selected={laneParticipantIds.includes(`${ele.id}-2`)}
              ele={ele}
              onLaneMouseDown={onLaneMouseDown}
              selectedLane={selectedLane}
              ind={ele.id}
            />
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RoleAssociationList;
